import {PaginatedContent} from '../../../application/contentLoaders/paginatedContent';
import {ReadyProvider} from '../../../application/providers/readyProvider';

ReadyProvider.executeOnReady(() => {
    let pageContent = new PaginatedContent(document.querySelector('[data-page="content"]')),
        categoryFilter = document.querySelector('[data-filter="category"]');

    if (categoryFilter) {
        categoryFilter.addEventListener('change', (event) => {
            pageContent.setFilter('category', event.currentTarget.value);
            pageContent.reload();
        });
    }
});
